import $ from "jquery";

const addStyle = (() => {
    const style = document.createElement("style");
    document.head.append(style);
    return (styleString: string) => (style.textContent = styleString);
})();

function adjustForHeaderBanners() {
    let bannerSize = 0;
    $.each($(".header-banner"), function (_index, banner) {
        bannerSize = bannerSize + ($(banner).height() ?? 0);
    });
    const headerBaseHeight = $(".header-wrapper").outerHeight() ?? 0;

    addStyle(`
        :root {
            --size-header-banner: ${bannerSize}px;
            --size-header: ${headerBaseHeight}px;
        }`);
}

$(function () {
    // Header banner offsets
    adjustForHeaderBanners();

    const myObserver = new ResizeObserver((entries) => {
        // ReSharper disable once UnusedParameter
        entries.forEach(() => {
            adjustForHeaderBanners();
        });
    });

    const someEl = document.querySelector(".header-sticky");
    if (someEl === null) return;
    myObserver.observe(someEl);
});
